/* ==========================================================================
   Parlez  -  "choosing a size means in stock"      assets/parlez-stock-sizes.js

   Problem: Shopify's Size filter matches every size listed on a product, even
   if that size is sold out. So choosing XXL also showed products where XXL has
   sold out.

   Fix: Shopify has a separate "Availability" filter (In stock / Out of stock)
   and it is matched against the SAME variant as the size. So while a size is
   ticked, this file ticks the "In stock" box for the visitor, behind the scenes.

   What this file does (Dawn's own assets/facets.js still does the filtering):
     1. Ticks "Availability: In stock" while any size is ticked, and unticks it
        when the last size is unticked.
     2. Hides the Availability group from the filter lists, and its "In stock"
        tag from the row of chosen filters, so the visitor only ever sees Size.
     3. Makes the "x" on a Size tag (and the group's Reset link) remove the
        in-stock setting too, instead of leaving it behind.
     4. Corrects the numbers in the Size list. Shopify counts every product that
        lists a size, sold out or not, until a size is ticked. This asks Shopify
        for the "in stock" numbers and puts them in the list straight away, and
        greys out a size that nothing has in stock.

   Needs: the Availability filter switched on in the Search & Discovery app.
   Load it once, next to facets.js (see the instructions).
   ========================================================================== */
(function () {
  'use strict';

  if (window.__parlezStockSizes) return;
  window.__parlezStockSizes = true;

  var SIZE = 'filter.v.option.size'; // the filter that means "in stock" (its name in the web address)
  var STOCK = 'filter.v.availability'; // Shopify's Availability filter

  /* ---- 2a. hide the Availability group (desktop list and phone drawer) ---- */
  var style = document.createElement('style');
  style.textContent = '.js-filter:has(input[name="' + STOCK + '"]){display:none!important}';
  document.head.appendChild(style);

  /* ---- 1. keep "In stock" in step with the sizes ---- */
  function syncStock(form) {
    var inStock = form.querySelector('input[name="' + STOCK + '"][value="1"]');
    if (!inStock) return;

    var sizeTicked = !!form.querySelector('input[name="' + SIZE + '"]:checked');
    inStock.disabled = false; // Shopify greys the box out when it would show nothing; a disabled box is never sent
    inStock.checked = sizeTicked;

    if (sizeTicked) {
      var outOfStock = form.querySelector('input[name="' + STOCK + '"][value="0"]');
      if (outOfStock) outOfStock.checked = false; // never both
    }
  }

  // Capture phase on the document = runs before Dawn builds the new web address
  // (Dawn waits a moment after a tick, so this is always first).
  document.addEventListener(
    'input',
    function (event) {
      var form = event.target.closest && event.target.closest('facet-filters-form form');
      if (form) syncStock(form);
    },
    true
  );

  /* ---- 3. the little "x" tags and Reset links ---- */
  // Each one is a link to the page with that one choice removed. If that leaves no
  // size but still has "in stock", take "in stock" out too.
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('facet-remove a, .active-facets a');
      if (!link || !link.href) return;

      var url = new URL(link.href, window.location.href);
      if (url.searchParams.has(STOCK) && !url.searchParams.has(SIZE)) {
        url.searchParams.delete(STOCK);
        link.href = url.pathname + url.search; // Dawn reads link.href when it handles the click
      }
    },
    true
  );

  /* ---- 2b. hide the "Availability: In stock" tag while a size is chosen ---- */
  function hideStockTag() {
    var now = new URL(window.location.href).searchParams;
    var sizeChosen = now.has(SIZE) && now.has(STOCK);

    document.querySelectorAll('.active-facets facet-remove').forEach(function (tag) {
      var link = tag.querySelector('a');
      if (!link) return;
      // The tag for Availability is the one whose "remove" link still has the size in it but no
      // Availability. (A Size tag's link still has Availability; "Remove all" has neither.)
      var params = new URL(link.href, window.location.href).searchParams;
      var isStockTag = sizeChosen && params.has(SIZE) && !params.has(STOCK);
      tag.style.display = isStockTag ? 'none' : '';
    });
  }

  /* ---- 4. the numbers in the Size list ---- */
  // Shopify gives the right (in stock) numbers when "in stock" is part of the search, so we
  // ask for that version of the same page in the background and copy its numbers across.
  // The products on the page are not touched. Answers are kept, so each search is asked once.
  var stockCounts = {}; // search -> promise of { 'XL': { n: 307, off: false }, ... }

  function sectionId() {
    var el = document.getElementById('product-grid') || document.getElementById('main-collection-filters');
    return el && el.dataset.id;
  }

  function loadStockCounts() {
    var now = new URL(window.location.href);
    if (now.searchParams.has(STOCK)) return null; // "in stock" is already part of this search, so the numbers are right
    var id = sectionId();
    if (!id) return null;

    var params = new URLSearchParams(now.search);
    params.delete('page');
    params.set(STOCK, '1');
    var key = params.toString();

    if (!stockCounts[key]) {
      stockCounts[key] = fetch(now.pathname + '?section_id=' + encodeURIComponent(id) + '&' + key)
        .then(function (response) {
          return response.ok ? response.text() : Promise.reject(new Error('no answer'));
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var counts = {};
          doc.querySelectorAll('input[name="' + SIZE + '"]').forEach(function (input) {
            var item = input.closest('li');
            var label = item && item.querySelector('.facet-checkbox__text');
            var found = label && label.textContent.match(/\((\d+)\)\s*$/);
            if (found) counts[input.value] = { n: Number(found[1]), off: input.disabled && !input.checked };
          });
          return counts;
        })
        .catch(function () {
          delete stockCounts[key]; // try again next time
          return null;
        });
    }
    return stockCounts[key];
  }

  function applyCounts(counts) {
    document.querySelectorAll('facet-filters-form form input[name="' + SIZE + '"]').forEach(function (input) {
      var count = counts[input.value];
      var item = input.closest('li');
      if (!count || !item) return;

      // the "(226)" you see, and the same number in the text screen readers use
      var shown = item.querySelector('.facet-checkbox__text');
      var spoken = item.querySelector('.visually-hidden');
      [shown, spoken].forEach(function (holder, index) {
        if (!holder) return;
        Array.prototype.forEach.call(holder.childNodes, function (node) {
          var pattern = index === 0 ? /\(\d+\)/ : /\(\s*\d+/;
          if (node.nodeType !== 3 || !pattern.test(node.nodeValue)) return;
          var text = node.nodeValue.replace(pattern, index === 0 ? '(' + count.n + ')' : '(' + count.n);
          if (text !== node.nodeValue) node.nodeValue = text;
        });
      });

      // nothing in stock in that size: grey it out, as Shopify does for an empty value
      if (!input.checked) {
        input.disabled = count.off;
        var label = input.closest('label');
        if (label) label.classList.toggle('disabled', count.off);
      }
    });
  }

  function refreshCounts() {
    var asked = loadStockCounts();
    if (!asked) return;
    var search = window.location.search;
    asked.then(function (counts) {
      if (counts && search === window.location.search) applyCounts(counts); // ignore an answer for a search the visitor has already left
    });
  }

  /* ---- run now, and again whenever Dawn redraws the page after a tick ---- */
  var queued = false;
  function queueTidy() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      hideStockTag();
      refreshCounts();
    });
  }

  new MutationObserver(queueTidy).observe(document.documentElement, { childList: true, subtree: true });
  hideStockTag();
  refreshCounts();
})();